import { getRootContainerProps } from "@client/content/lib/helper";
import { ModuleButton } from "@client/content/modules/Button";
import { type RootContainerProps } from "@client/content/types";
import { type FormButtonProps } from "@client/controls/Form/component";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";

export type MapProps = RootContainerProps & {
  isDisabled: boolean;
  captionKey?: string;
};

export type ActionProps = {
  onClick: (data: any) => void;
};

type OwnProps = ActionProps & MapProps;
type Props = FormButtonProps & OwnProps;
export default (props: Props) => {
  const i18n = useI18n();

  return (
    <ModuleButton
      {...getRootContainerProps(props)}
      isDisabled={props.isDisabled}
      onClick={props.ifValidated((data) => props.onClick(data))}
      caption={props.captionKey ? i18n[props.captionKey] : undefined}
    />
  );
};
